import { Link } from "react-router-dom";
import { Marquee } from "@/components/Marquee";
import { COURSES, VERTICALS } from "@/constants/site";

export default function Home() {
  return (
    <div data-testid="home-page">
      {/* HERO */}
      <section
        className="py-24 md:py-32 bg-[#0c1427] text-[#dce7f9] border-b border-[#203154] relative"
        data-testid="home-hero"
      >
        <div className="max-w-6xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#162544] border border-[#203154] text-[#38bdf8] font-mono text-xs uppercase tracking-widest mb-8 d3-reveal">
            Adipurusa Infotech · Hyderabad to Global
          </div>
          <h1 className="font-heavy text-[clamp(42px,5.5vw,84px)] uppercase text-white leading-[0.92] tracking-tight mb-8">
            <span className="ln"><span>Hands-on Projects.</span></span>
            <span className="ln"><span className="text-[#38bdf8]">Enterprise Results.</span></span>
          </h1>
          <p className="text-base md:text-xl text-[#9cb4d8] leading-relaxed max-w-2xl mx-auto mb-10 d3-reveal">
            High-impact training with top placement records, beside full-lifecycle product
            development and IT services.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto text-left d3-reveal">
            <div className="p-6 rounded-xl bg-[#162544] border border-[#203154] flex flex-col justify-between">
              <div>
                <div className="text-xs font-mono text-[#38bdf8] uppercase tracking-wider mb-2">
                  01 / For Students
                </div>
                <h3 className="text-lg font-bold text-white mb-2">Job-Oriented Tech Courses</h3>
                <p className="text-xs text-[#9cb4d8] mb-4">
                  Learn AI, Data Science, SAP, Oracle, and Microsoft with industry-expert trainers
                  and hands-on projects.
                </p>
              </div>
              <Link
                to="/courses"
                data-testid="hero-student-cta"
                className="inline-block py-2.5 px-4 rounded bg-[#38bdf8] text-[#0c1427] text-xs font-bold font-mono uppercase tracking-wider text-center hover:bg-white transition-colors"
              >
                Browse Courses &amp; Apply →
              </Link>
            </div>

            <div className="p-6 rounded-xl bg-[#162544] border border-[#203154] flex flex-col justify-between">
              <div>
                <div className="text-xs font-mono text-[#38bdf8] uppercase tracking-wider mb-2">
                  02 / For Enterprises
                </div>
                <h3 className="text-lg font-bold text-white mb-2">IT Delivery &amp; Products</h3>
                <p className="text-xs text-[#9cb4d8] mb-4">
                  Turnkey software builds, cloud modernization, and dedicated IT technical
                  consulting.
                </p>
              </div>
              <Link
                to="/services"
                data-testid="hero-enterprise-cta"
                className="inline-block py-2.5 px-4 rounded bg-[#203154] text-white text-xs font-bold font-mono uppercase tracking-wider text-center hover:bg-[#38bdf8] hover:text-[#0c1427] transition-colors"
              >
                Explore Services →
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Marquee />

      {/* VERTICALS */}
      <section
        className="py-24 md:py-32 bg-[#0c1427] text-[#dce7f9] border-b border-[#203154]"
        data-testid="home-verticals"
      >
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center max-w-2xl mx-auto mb-16">
            <div className="text-xs font-mono uppercase tracking-widest text-[#38bdf8] mb-3">
              Enterprise Capabilities
            </div>
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-white">
              Three High-Impact Verticals
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {VERTICALS.map((v) => (
              <div
                key={v.num}
                className="p-8 rounded-xl bg-[#162544] border border-[#203154] flex flex-col justify-between"
                data-testid={`vertical-card-${v.num}`}
              >
                <div>
                  <div className="text-2xl font-bold font-mono text-[#38bdf8] mb-4">{v.num}</div>
                  <h3 className="text-xl font-bold text-white mb-3">{v.title}</h3>
                  <p className="text-xs text-[#9cb4d8] leading-relaxed mb-6">{v.blurb}</p>
                </div>
                <Link
                  to="/services"
                  data-testid={`vertical-link-${v.num}`}
                  className="text-xs font-mono uppercase text-[#38bdf8] hover:text-white transition-colors"
                >
                  Learn More →
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* COURSES PREVIEW */}
      <section
        className="py-24 md:py-32 bg-[#101b33] text-[#dce7f9] border-b border-[#203154]"
        data-testid="home-courses-preview"
      >
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
            <div>
              <div className="text-xs font-mono uppercase tracking-widest text-[#38bdf8] mb-3">
                Student Hub
              </div>
              <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-white">
                Programs &amp; Curriculums
              </h2>
            </div>
            <p className="text-sm text-[#9cb4d8] max-w-sm">
              Every course includes capstone projects, resume reviews, and placement assistance.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {COURSES.slice(0, 3).map((c) => (
              <div
                key={c.track}
                className="p-6 rounded-xl bg-[#0c1427] border border-[#203154]"
                data-testid={`home-course-${c.track.replace(" ", "-").toLowerCase()}`}
              >
                <div className="text-xs font-mono text-[#38bdf8] uppercase mb-2">{c.track}</div>
                <h3 className="text-lg font-bold text-white mb-2">{c.name}</h3>
                <p className="text-xs text-[#9cb4d8]">{c.blurb}</p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/courses"
              data-testid="home-all-courses-cta"
              className="inline-block py-3 px-8 rounded bg-[#38bdf8] text-[#0c1427] text-xs font-bold font-mono uppercase tracking-wider hover:bg-white transition-colors"
            >
              View All Programs →
            </Link>
          </div>
        </div>
      </section>

      {/* ABOUT TEASER */}
      <section
        className="py-24 md:py-32 bg-[#0c1427] text-[#dce7f9]"
        data-testid="home-about-teaser"
      >
        <div className="max-w-6xl mx-auto px-6">
          <div className="max-w-3xl">
            <div className="text-xs font-mono uppercase tracking-widest text-[#38bdf8] mb-3">
              Company Overview
            </div>
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-white mb-6">
              Empowering Ambition with Engineering Rigor
            </h2>
            <p className="text-sm text-[#9cb4d8] leading-relaxed mb-8">
              Adipurusa Infotech Private Limited operates at the convergence of technology
              education and real-world engineering. We combine industry-veteran trainers with a
              high-capacity software development studio.
            </p>
            <Link
              to="/about"
              data-testid="home-about-cta"
              className="text-xs font-mono uppercase text-[#38bdf8] hover:text-white transition-colors"
            >
              More About Us →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
